import React from 'react';
import { Button } from '@mui/material';
import { Tooltip_Next as Tooltip } from '@zs-nimbus/core';
import { useSnackbar } from 'notistack';

const TRUNCATE_LENGTH = 40;

const CopyableLink = ({ link, label }: { link: string; label?: string }) => {
  const { enqueueSnackbar } = useSnackbar();
  const text = label || link;
  const isTruncated = text.length > TRUNCATE_LENGTH;
  const displayText = isTruncated ? `${text.slice(0, TRUNCATE_LENGTH)}…` : text;
  const showTooltip = isTruncated || (!!label && label !== link);

  const copyToClipboard = () => {
    if (link) {
      navigator.clipboard.writeText(link).then(() => {
        enqueueSnackbar('Link copied to clipboard', { variant: 'success', key: Date.now() });
      });
    }
  };

  const linkElement = (
    <Button
      variant="primaryText"
      size="small"
      onClick={copyToClipboard}
      sx={{
        cursor: 'copy',
        verticalAlign: 'baseline',
        textDecoration: 'underline',
        '&:hover': { textDecoration: 'none' },
      }}>
      {displayText}
    </Button>
  );

  return showTooltip ? (
    <Tooltip content={<div style={{ maxWidth: 650, wordBreak: 'break-all' }}>{link}</div>} trigger={linkElement} />
  ) : (
    linkElement
  );
};

export default CopyableLink;
